import { createSlice } from "@reduxjs/toolkit";
import {
  caseChecklistVerificationAction,
  getChecklistByCaseTypeIDAction,
  bulkChecklistExcelAction
} from "../../actions/CaseChecklistTab/caseChecklistTabAction";

const initialState = {
  checklistData: [],
  filteredChecklists: [],
  loading: false,
  error: null,
};

const checklistVerificationSlice = createSlice({
  name: "checklistVerification",
  initialState,
  reducers: {
    resetChecklistError: (state) => {
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(caseChecklistVerificationAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(caseChecklistVerificationAction.fulfilled, (state, action) => {
        state.loading = false;
        state.checklistData = action.payload || [];
      })
      .addCase(caseChecklistVerificationAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getChecklistByCaseTypeIDAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(getChecklistByCaseTypeIDAction.fulfilled, (state, action) => {
        state.loading = false;
        state.filteredChecklists = action.payload?.data || [];
      })
      .addCase(getChecklistByCaseTypeIDAction.rejected, (state, action) => {
        state.loading = false;
        state.filteredChecklists = [];
      })
      .addCase(bulkChecklistExcelAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bulkChecklistExcelAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(bulkChecklistExcelAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetChecklistError } = checklistVerificationSlice.actions;
export default checklistVerificationSlice.reducer;

